module.exports = __webpack_public_path__ + "img/up-right-icon.48f797d1.svg";